<!-- 登录选择 -->
<template>
  <div class="loginlistpage">
    <div class="newHeadBox">
      <div class="logoBox">
        <div class="logo"></div>
        <div class="textTitle">
          <p class="host-Tit">
            <span>国家卫生健康委智慧健康服务平台</span>
          </p>
          <p class="sub-Tit">全国公立医疗卫生机构短缺药品信息直报系统</p>
        </div>
      </div>

    </div>
    <!--ip 换域名提示-->
    <div class="temporaryHintW" style="display:none;">
      <ul>
        <li><span>2023年底</span>将停止IP地址访问</li>
        <li>请使用域名访问<a href="https://zhibao.yjglzx.org.cn">https://zhibao.yjglzx.org.cn</a>(该域名仅适用于互联网)</li>
        <li>请点击'<a href="javascript:;" @click="shoucang">收藏</a>'(如不能自动收藏，请手动添加到收藏)</li>
      </ul>
    </div>
    <div class="loginimg">
      <div class=" loginform">
          <p class="welcome">欢迎登录</p>
          <ul class="loginUl">
            <li class="oneLi"  @click="tourl(0)">
              <div>
                <span class="hots-tit">医疗机构</span>
                <span class="sub-tit">(填报端)</span>
              </div>
              <img src="../../../static/image/jiantou-1.jpg">
            </li>
            <li class="oneLi twoLi"  @click="tourl(1)">
              <div>
                <span class="hots-tit">各级主管部门</span>
                <span class="sub-tit">(管理端)</span>
              </div>
              <img src="../../../static/image/jiantou-2.jpg">
            </li>
            <li class="oneLi threeLi"  @click="tourl(2)">
              <div>
                <span class="hots-tit">省级药企单位</span>
                <span class="sub-tit">(响应端)</span>
              </div>
              <img src="../../../static/image/jiantou-3.jpg">
            </li>
          </ul>
          <!-- <div class="font32 textalign_c">全国公立医疗卫生机构短缺药品信息直报系统</div> -->
          <!-- <div class="loginli" @click="tourl(0)">
          	<img src="../../../static/image/reported.png" alt="">
          	<p>医疗机构（填报端）</p>
          </div>
          <div class="loginli" @click="tourl(1)">
          	<img src="../../../static/image/manage.png" alt="">
          	<p>各级主管部门（管理端）</p>
          </div>
          <div class="loginli" @click="tourl(2)">
          	<img src="../../../static/image/manage.png" alt="">
          	<p>省级药企单位（响应端）</p>
          </div> -->
          <!-- <a class="jumpClass" href="../../static/file/GoogleChrome.msi">下载谷歌内核</a> -->
      </div>
      <!-- <div class="copyright">版权所有:国家卫生健康委药具管理中心</div>
      <div class="icp"><a target="_blank" href="http://beian.miit.gov.cn/">京ICP备20003295号-1</a></div> -->
    </div>
    <div class="newFootBox">
      <div class="friend-link">
        <span>相关链接：</span>
        <a href="https://www.nhc.gov.cn/" target="_blank">中华人民共和国国家卫生健康委员会</a>
        <!-- <a href="" target="_blank">国家卫生健康委智慧健康服务平台</a> -->
      </div>
      <div class="emailBox">
        <span>地址：北京市海淀区皂君庙东路甲14号</span>
        <span>客服电话：400-6600-9993</span>
        <span><a target="_blank" href="http://beian.miit.gov.cn/">ICP安备编号：京ICP备20003295号-1</a></span>
      </div>
      <div class="emailBox">
        <span>国家卫生健康委药具管理中心 版权所有</span>
        <span>技术支持 短缺药品应对处</span>
      </div>
    </div>
  </div>
</template>
<script>
  import {setCookie} from '../../../static/js/cookie.js'
  import {delCookie} from '../../../static/js/cookie.js'
  export default {
    data() {
      return {
        
      };
    },
    methods: {
      shoucang(){
        this.$alert("您好，您的浏览器暂不支持自动添加收藏功能，请手动添加收藏", "提示", {
          cofirmButtonText: "确定",
          type: "warning"
        });
      },
      tourl(eve){
        setCookie('loginType',eve)
        // if(eve===0){
        //   this.$router.push({path:"/login",query:{lgs:eve}})
        // }else{
        //   this.$router.push({path:"/login",query:{lgs:eve}})
        // }
        if(eve=="2"){//药品企业
          this.$router.push({path:"/loginDrugFirm",query:{lgs:eve}})
        }else{
          this.$router.push({path:"/login",query:{lgs:eve}})
        }
        
      }
    },
    mounted(){
      delCookie('newsFlag');
      delCookie('userInfo');
      //this.tourl(1)
    }
  }
</script>
<style lang="less">
  .newHeadBox {
    height: 86px;background: #fff;border-bottom: 1px solid #D1D4D8; 
    .logoBox {display: flex;width: 1100px; height: 100%;margin: 0 auto;}
    .logo {width: 60px;height: 60px;background:url('../../../static/image/logoG.png') no-repeat center center;
      margin-right: 7px;align-self: center;
    }
    .textTitle {align-self: center;
      .host-Tit span{font-size: 18px;background: #004CA0; color: #fff;letter-spacing: 2px;}
      .sub-Tit{font-size: 24px;color: #004CA0;line-height: 30px;margin-top:5px;}

    }
  }
  .newFootBox {background: #1E2C45;text-align: center;padding: 15px 0;position: fixed;
    bottom: 0;
    height: 90px;
    width: 100%;
    .friend-link {margin-bottom: 5px; text-align: center;
      span {font-size: 14px;color: #FFFFFF;line-height: 28px; }
      a {font-size: 14px;color: #FFFFFF;line-height: 28px;text-decoration: underline;margin-right:15px;}
    }
    .emailBox { text-align: center;
      span {font-size: 12px;color: #FFFFFF;line-height: 28px;margin:0 10px;}
      a {font-size: 12px;color: #FFFFFF;line-height: 28px; text-decoration: none;}
    }
  }


  .loginlistpage{
    width: 100%;
    // min-height: 700px;
    
    height: 100%;
    background:url('../../../static/image/body-bg.png') no-repeat center center;
    background-size: contain;
    /* background: -webkit-linear-gradient(left, #1abc9c, #16a085);
    background: -o-linear-gradient(right, #1abc9c, #16a085);
    background: -moz-linear-gradient(right, #1abc9c, #16a085);
    background: linear-gradient(to right, #1abc9c, #16a085); */
    /* z-index: -2; */
  }  
  .temporaryHintW {
    position:absolute;padding:10px 10px 10px 60px;
    bottom:70px;
    left:50%;margin-left:-350px;
    background:url('../../../static/image/hintIon.svg') no-repeat -65px center;
    background-size:25% 25%;
    width:700px;background-color:rgba(255,255,255,.15)
  }
  .temporaryHintW ul {margin:0;padding:0;}
  .temporaryHintW ul li{color:#fff;font-size: 26px; line-height: 32px;margin-top:10px;}
  .temporaryHintW ul li span  {color: #fff;font-size: 26px;}
  .temporaryHintW ul li a  {color: #fff;font-size: 26px;word-break: break-all;text-decoration: none;}
  
  .loginlistpage .jumpClass{
    color: red;
    font-size: 24px;
    font-weight: bold;
    display: inline-block;
    width: 100%;
    text-align: center;
    margin-top: 50px;
  }
  .loginlistpage .loginimg{
    display: flex;
    justify-content: flex-end;
    width: 1100px;
    // min-height: 700px;
    // height: 100%;
    height: 500px;
    background:url(../../../static/image/login-bg.png) no-repeat center center;
    margin:30px auto 0;
    border-radius: 8px;

    // background-size: 80%;
    // background-position: 50% 0;
    // background-repeat: no-repeat;
    // z-index: -1;
  }
  .loginlistpage .loginform{
    height: 500px;
    width: 450px;
    background: #fff;
    border-radius: 10px 8px 8px 10px;
    padding:50px 50px 0;box-sizing: border-box;
  }

  .loginlistpage{
    .loginform { 
    
      .welcome { font-size: 32px;color: #000;margin-bottom: 20px; font-weight: bold;}
      .loginUl{ margin: 0; padding: 0;
        li {
          display: flex;width:328px;height: 100px;  border-radius:8px ;justify-content: space-between;
    box-sizing: border-box;padding:20px; margin-bottom:20px; cursor: pointer;
          img {display: block; width: 30px;height: 30px;align-self: center;}
        }
        li.oneLi {background: linear-gradient(to right, #F9FFFD, #F1FFF9);border:2px solid #ccc;
          span {display: block;}
          .hots-tit { font-size:18px; color:#278857; font-weight: bold;line-height: 30px;}
          .sub-tit { font-size:14px; color:#278857;line-height: 28px; }
        }
        li.oneLi:hover {border:2px solid #278857;} 

        li.twoLi {background: linear-gradient(to right, #FFFDF8, #FFFBEC);
          .hots-tit {  color:#8A6212; }
          .sub-tit {  color:#8A6212; }
        }
        li.twoLi:hover {border:2px solid #8A6212;} 

        li.threeLi {background: linear-gradient(to right, #F8FBFF, #EEF5FF);
          .hots-tit { color:#3D5C99; }
          .sub-tit {  color:#3D5C99; }
        }
        li.threeLi:hover {border:2px solid #3D5C99;} 

      }
    }
  }
  
  
  
  .loginlistpage .font32{
    font-size: 32px;
    margin-bottom: 54px;
    color: #fff;
    letter-spacing: 3px;
    font-weight: 600;
  }
  .loginlistpage .el-icon-user{
    background-repeat: no-repeat;
    background-size: 14px 18px;
    background-position: 10px 10px;
    display: block;
    background-image: url(../../../static/image/icon/user.png);
  }
  .loginlistpage .el-icon-pass{
    background-repeat: no-repeat;
    background-size: 14px 18px;
    background-position: 10px 10px;
    display: block;
    background-image: url(../../../static/image/icon/password.png);
  }
  .loginlistpage .el-icon-phonec{
    background-repeat: no-repeat;
    background-size: 14px 18px;
    background-position: 10px 10px;
    display: block;
    background-image: url(../../../static/image/icon/phone.png);
  }
  .loginlistpage .el-input__icon{
    width: 44px;
  }
  .loginlistpage .el-input__inner{
    height: 42px;
    line-height: 42px;
  }
  .loginlistpage .el-input--prefix .el-input__inner {
    padding-left: 42px;
  }
  .loginlistpage .phonecode{
    width: 219px;
    margin-right: 12px;
    float: left;
  }
  .loginlistpage .sendcode{
    width: 95px;
    padding: 12px 0;
    height: 42px;
  }
  .loginlistpage .submit{
    width: 100%;
    margin-top: 26px;
    font-size: 18px;
    line-height: 10px;
    height: 42px;
  }
  .loginlistpage .copyright{
    text-align: center;
    bottom: 45px;
    width: 100%;
    position: fixed;
    color: #FFFFFF;
    font-size: 12px;
    z-index: 1;
  }
  .loginlistpage .icp{
    text-align: center;
    bottom: 30px;
    width: 100%;
    position: fixed;
    font-size: 12px;
    z-index: 1;
  }
  .loginlistpage .el-input__suffix .el-icon-circle-close{
    display: none;
  }
  .loginlistpage .el-form-item__content .el-form-item__error{
    top: 12px;
    right: 10px;
    left: auto;
  }
  .loginlistpage .phonecodeli .el-form-item__content .el-form-item__error{
    top: 10px;
    right: 118px;
    left: auto;
  }

</style>



// WEBPACK FOOTER //
// src/views/user/loginlist.vue